import { render, staticRenderFns } from "./UserAccountMenu.vue?vue&type=template&id=5a54f0e8&scoped=true"
import script from "./UserAccountMenu.vue?vue&type=script&lang=js"
export * from "./UserAccountMenu.vue?vue&type=script&lang=js"
import style0 from "./UserAccountMenu.vue?vue&type=style&index=0&id=5a54f0e8&prod&scoped=true&lang=css"
import style1 from "./UserAccountMenu.vue?vue&type=style&index=1&id=5a54f0e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a54f0e8",
  null
  
)

export default component.exports